// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1__c8084551c6f9f7bcc1e8","cls2":"ContentFeedback-cls2___d44aceb22fd4d572480 ContentFeedback-cls1__c8084551c6f9f7bcc1e8"};